module.exports = __webpack_public_path__ + "media/images/icons/logout2x-1c63723ae1b60a7362c9bcbadf3c864e.png";